import React, { useEffect, useRef } from "react";
import tippy, { Instance } from "tippy.js";

const TechCard = (props: any) => {
  const tooltipRefs = useRef<Instance[]>([]);

  useEffect(() => {
    tooltipRefs.current = [];
    const iconTooltips = document.querySelectorAll('.tech-card');
    iconTooltips.forEach((element) => {
      const tooltip = tippy(element, {
        content: element.getAttribute('title') || '',
      });
      tooltipRefs.current.push(tooltip);
    });

    return () => {
      tooltipRefs.current.forEach((tooltip) => {
        tooltip.destroy();
      });
    };
  }, []);
  return (
    <>
      <span className="tech-card" title={props.name} key={props.name}>
      <span className="medium iconify mySpan" data-icon={props.logo}></span>
      </span>
    </>
  );
};

export default TechCard;